
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';

const Header = () => {
  const { user, signOut } = useAuth();

  return (
    <header className="bg-white shadow">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img 
            src="/lovable-uploads/d6f3215b-82a9-4aca-8941-f8a820e7beb5.png" 
            alt="Figabl Logo" 
            className="h-8 w-auto mr-2"
          />
        </Link>
        
      </div>
    </header>
  );
};

export default Header;
